// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 644 ? "3b1baa31" : chunkId) + "." + {"154":"ba9bf824174ee53a","431":"2509ea4829fafcb2","644":"ef7baee7128ca8f8"}[chunkId] + ".js";
};